import { Link } from 'react-router-dom';
import { FullFooter } from '@/components/Footer';
import SubscribeForm from '@/components/SubscribeForm';
import newsletterIssues from '@/data/newsletterIssues';

const IssueCard = ({ issue }) => (
  <Link to={`/newsletter/${issue.slug}`} className="nl-issue-card">
    <span className="nl-issue-num">{issue.num}</span>
    <h3 className="nl-issue-title">{issue.title}</h3>
    <div className="nl-issue-meta">
      <span className="nl-issue-date">{issue.date}</span>
      <span className="nl-issue-arrow">&rarr;</span>
    </div>
  </Link>
);

const Newsletter = ({ showToast, onSubscribe }) => {
  return (
    <>
      {/* Hero with subscribe */}
      <section className="nl-hero" data-testid="newsletter-hero">
        <div className="nl-hero-inner">
          <div className="nl-hero-eyebrow">Free — Every Tuesday</div>
          <h1 className="nl-hero-title">One newsletter. Everything on Treasury Companies.</h1>
          <p className="nl-hero-sub">Treasury companies, Bitcoin, macro shifts, and the signals that move markets. One letter, every Tuesday.</p>
          <SubscribeForm showToast={showToast} className="nl-hero-form" />
          <p className="nl-hero-proof">Join 50+ crypto investors who start their Tuesday with Nile Capital.</p>
        </div>
      </section>

      {/* Past issues grid */}
      <section className="nl-past-issues">
        <div className="nl-section-inner">
          <h2>Past Issues</h2>
          <div className="nl-issues-grid">
            {newsletterIssues.map((issue) => (
              <IssueCard key={issue.slug} issue={issue} />
            ))}
          </div>
        </div>
      </section>

      {/* Bottom CTA */}
      <section className="nl-bottom-cta">
        <div className="nl-section-inner">
          <h2>Start reading. It's free.</h2>
          <p>No credit card. No commitment. Delivered every Tuesday.</p>
          <SubscribeForm showToast={showToast} className="cta-centered" />
        </div>
      </section>

      <FullFooter onSubscribe={onSubscribe} />
    </>
  );
};

export default Newsletter;
